import React from 'react';
import { Link } from 'react-router-dom'; // Import Link for navigation
import axios from 'axios';
import {toast } from "react-toastify";

function Clients({ clients = [], onClientDeleted, openEditClientForm }) {

  const handleDelete = async (id) => {
    const token = localStorage.getItem("token");
    if (window.confirm("Are you sure you want to delete this client?")) {
      try {
        await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/client/${id}`,{
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        });
      
      toast.success("Client deleted successfully.");

        onClientDeleted && onClientDeleted(); // Optional callback to refresh list
      } catch (error) {
        console.error("Error deleting client:", error);
        toast.error("Failed to delete client");
      }
    }
  };

  const handleGenerateContract = async (clientOrId) => {
    const token = localStorage.getItem("token");
    // Accept either a client object or a raw id string
    const clientId = clientOrId && clientOrId._id ? clientOrId._id : (typeof clientOrId === 'string' ? clientOrId : null);
    if (!clientId) {
      toast.error('Client id is missing — cannot generate contract');
      return;
    }

    try {
      const resp = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/client/${encodeURIComponent(clientId)}/create-contract`, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });

      const blob = new Blob([resp.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      // If we were passed the full client object, use its name for filename; otherwise fallback to id
      const safeName = (clientOrId && clientOrId.clientName) ? String(clientOrId.clientName).replace(/[^a-z0-9-_\.]/gi, '_') : clientId;
      a.download = `${safeName}_contract.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      toast.success('Contract generated and downloaded');
    } catch (error) {
      console.error('Error creating contract:', error);
      const msg = (error && error.response && error.response.data && error.response.data.message) || 'Failed to create contract';
      toast.error(msg);
    }
  };

  if (!clients.length) {
    return <div className="text-gray-400">No clients found.</div>;
  }

  return (
    <div className="space-y-4">
      {clients.map((client) => (
        <div
          key={client._id}
          className="flex flex-col md:flex-row items-start bg-white rounded-xl shadow-md border border-gray-200 p-4 gap-4"
        >
          <div className="flex-shrink-0 w-full md:w-1/4 h-24 bg-gray-100 rounded-lg flex items-center justify-center text-gray-400 text-sm">
            👤 Client
          </div>

          <div className="flex-1">
            {/* Make client name clickable to navigate to details */}
           <Link to={`/myclients/details/${client._id}`} className="hover:underline hover:text-blue-600 transition duration-200">
    <h2 className="text-xl font-semibold mb-1">
      {client.clientName || 'Unnamed Client'}
    </h2>
</Link>
            <p className="text-gray-600 mb-1">
              <span className="font-medium">Company:</span> {client.company || '—'}
            </p>
            <p className="text-gray-600 mb-1">
              <span className="font-medium">Email:</span> {client.Email || '—'}
            </p>
            <p className="text-gray-600">
              <span className="font-medium">Contact:</span> {client.contact || '—'}
            </p>
          </div>

          <div className="flex flex-col gap-2 mt-4 md:mt-0 md:ml-auto">
            <button
              onClick={() => openEditClientForm(client)}
              className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded text-sm transition duration-200"
            >
              Edit
            </button>
            <button
              onClick={() => handleDelete(client._id)}
              className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded text-sm transition duration-200"
            >
              Delete
            </button>
            
              <button
                onClick={() => handleGenerateContract(client._id)}
                className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded text-sm transition duration-200"
              >
                Generate Contract
              </button>
            
          </div>
        </div>
      ))}
    </div>
  );
}

export default Clients;
